<template>
    <fieldset :disabled="isDisabled">
        <form novalidate @submit.prevent="submit()">
            <div class="form-row">
                <div class="col-xl">
                    <TextField
                        id="name"
                        ref="autofocus"
                        v-model="name"
                        class="mb-0"
                        name="name"
                        size="sm"
                        required
                        translatable
                        maxlength="50"
                        :label="$t('links.fields.name.label')"
                        :placeholder="$t('links.fields.name.placeholder')"
                        :disabled="isDisabled"
                        :hide-validation="!isSubmitted"
                        :server-errors="serverErrors"
                        @validation="(fieldIsValid) => handleValidation('name', fieldIsValid)"
                        @keypress.enter.native.stop="submit()"
                        @keypress.esc.native.stop="cancel()" />
                </div>

                <div class="col-xl">
                    <UrlField
                        id="url"
                        v-model="url"
                        class="mb-0"
                        name="url"
                        size="sm"
                        required
                        :label="$t('links.fields.url.label')"
                        :placeholder="$t('links.fields.url.placeholder')"
                        :disabled="isDisabled"
                        :hide-validation="!isSubmitted"
                        :server-errors="serverErrors"
                        @validation="(fieldIsValid) => handleValidation('url', fieldIsValid)"
                        @keypress.enter.native.stop="submit()"
                        @keypress.esc.native.stop="cancel()" />
                </div>
            </div>
        </form>
    </fieldset>
</template>

<script>
import TextField from '@/js/components/common/fields/TextField';
import UrlField from '@/js/components/common/fields/UrlField';

import FormMixin from '@/js/mixins/FormMixin';

export default {
    name: 'LinkForm',

    components: {TextField, UrlField},

    mixins: [FormMixin],

    formFields: {
        name: true,
        url: true,
    },

    model: {prop: 'link'},

    props: {
        link: {type: Object, required: true},
    },

    watch: {
        formData: {
            deep: true,
            handler(data) {
                if (!this.isBooting) {
                    this.$emit('input', {...data});
                }
            },
        },
    },

    methods: {
        loadHook() {
            return {...this.link};
        },

        invalidHook() {
            this.$toastr.error(this.$t('notifications.errors.form-data'));
        },

        submitHook() {
            this.$emit('submit');

            return true;
        },

        cancel() {
            this.isSubmitted = false;
            this.$emit('cancel');
        },
    },
};
</script>
